<template>
    <div v-if="showModal" id="transfer_stock_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ partner.name }} - {{ product.name }}</h3>
            </div>
            <div id="body" class="ui segment">
                <table class="ui very basic table">
                    <thead>
                        <tr>
                            <th class="collapsing">센터명</th>
                            <th class="collapsing">재고수량</th>
                            <th class="collapsing">이관수량</th>
                            <th class="collapsing">최종수량</th>
                            <th class="collapsing"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <select class="ui simple dropdown" v-model="_fromCenterId" @change="onCenterChanged">
                                    <option v-for="c in getCenters()" :key="c._id" :value="c._id">{{ c.name }}</option>
                                </select>
                            </td>
                            <td class="collapsing">{{ product.centerStocks[_fromCenterId].count }}</td>
                            <td class="collapsing"> {{ -transferCount }} </td>
                            <td class="collapsing">{{ product.centerStocks[_fromCenterId].count - transferCount }}</td>
                        </tr>
                        <tr>
                            <td>
                                <select class="ui simple dropdown" v-model="_toCenterId" @change="onCenterChanged">
                                    <option v-for="c in getCenters()" :key="c._id" :value="c._id">{{ c.name }}</option>
                                </select>
                            </td>
                            <td class="collapsing">{{ product.centerStocks[_toCenterId].count }}</td>
                            <td class="collapsing">
                                <div class='ui fluid small input'>
                                    <input type="number" v-model.number="transferCount">
                                </div>
                            </td>
                            <td class="collapsing">{{ product.centerStocks[_toCenterId].count + transferCount }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class='ui fluid small input'>
                    <input type="text" placeholder="이관 상세내용" v-model="memo">
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div v-if="transferCount != 0" class="ui orange left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>저장
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, product: 0, partner: 0, _fromCenterId: 0, _toCenterId: 0, transferCount: 0, memo: 0, onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.product = this.partner = this._fromCenterId = this._toCenterId = this.transferCount = this.onChange = 0;
        this.memo = "";
    },
    mounted: function() {
        this.$event.set("transferStock", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("transferStock");
    },
    methods: {
        initStocks(product) {
            for (const center of this.centers) {
                if (!product.centerStocks[center._id]) {
                    product.centerStocks[center._id] = { add: 0, count: 0 };
                }
            }
            return product;
        },
        open(product, onChange) {
            const centers = this.getCenters();
            this.partner = this.partners.find((p) => p._id === product._partner);
            if (this.partner && centers.length > 1) {
                this.showModal = true;
                this.product = this.initStocks(product);
                this._fromCenterId = centers[0]._id;
                this._toCenterId = centers[1]._id;
                this.transferCount = 0;
                this.onChange = onChange;
            }
        },
        close() { this.showModal = false; },
        save() {
            if (this._fromCenterId == this._toCenterId) {
                alert("동일한 센터로 이관할 수 없습니다");
                return;
            }
            if (this.transferCount != 0) {
                this.$event.call("openLoading");
                this.$api.transferStocks(this.product._id, this._fromCenterId, this._toCenterId, this.transferCount, this.memo, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message)
                    } else {
                        this.close();
                        if (this.onChange) this.onChange();
                    }
                });
            }
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated)
                    array.push(center);
            }
            return array;
        },
        onCenterChanged() {
            this.transferCount = 0;
            this.$forceUpdate();
        }
    },
    computed: {
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
        isPartner: function() { return this.$store.getters.isPartner; },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(products) { this.$store.commit("setProducts", products); },
        },
    },
}
</script>

<style>
#transfer_stock_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#transfer_stock_modal .column {
    max-width: 600px;
}

#transfer_stock_modal #header {
    padding: 20px 30px;
}

#transfer_stock_modal #body {
    padding: 50px;
}

#transfer_stock_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#transfer_stock_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/StockModal_Transfer.vue